import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';

import {
    LOADING,
    LOAD_MANAGER_SUCCESS,
    SAVE_MANAGER_SUCCESS,
    CLEAR_MANAGER
} from '../types';
import MessageUtils from "../../utils/MessageUtils";

export const loadManager = (phone, email) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/user/find?phone=${phone}&email=${email}`;

        axios().get(url)
            .then(response => loadManagerSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:managerActions.findManagerFailure')));
    };
};

const loadManagerSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_MANAGER_SUCCESS, payload: response.data });
};

export const saveManager = (state) => {
    return (dispatch) => {

        // TODO move this into a common method
        // shared between saveManager and saveAdmin
        // since now they are one and the same

        const url = `/user`;

        const manager = {
            name: state.name,
            phone: state.phone,
            email: state.email,
            password: state.password,
            countryCode: state.countryCode,
            language: state.language,
            role: state.role,
            active: true
        };

        axios().post(url, manager)
            .then(response => saveManagerSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:managerActions.createAccFailure')));
    };
};

const saveManagerSuccess = (dispatch, response) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:adminsActions.saveUserSuccess'));
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: SAVE_MANAGER_SUCCESS, payload: response.data.data[0] });
};

export const clearManager = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_MANAGER });
    };
};



// WEBPACK FOOTER //
// ./src/actions/users/ManagersActions.js